<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <v-select class="col-lg-3 col-md-3" placeholder="Link" :options="uniquePlacementLinks"
          v-model="filters['link']"></v-select>
          <v-select class="col-lg-3 col-md-3" placeholder="Url" :options="uniquePlacementURL" v-model="filters['url']"></v-select>
          <v-select class="col-lg-3 col-md-3" placeholder="Indexed" :options="[{index: true, txt: 'Indexed'}, {index: false, txt: 'Not Indexed'}]" index="index" label="txt" v-model="filters['indexed']"></v-select>
        </div>
      </div>
      <div class="col-lg-12 m-t-sm">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th>#</th>
            <th>Link</th>
            <th>Url</th>
            <th>Anchor</th>
            <th>Status</th>
            <th>Pbn</th>
            <th>Client</th>
            <th>Placed</th>
            <th v-if="user.admin">Placer</th>
            <th>Confirmed</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(placement, i) in filterPlacedLinks" :key="placement.id">
            <td>{{ i + 1 }}</td>
            <td>{{ placement.link }}</td>
            <td>
              <a :href="placement.url" target="_blank" v-if="placement.url">{{ placement.url }} <i class="fa fa-external-link"></i></a>
              <span v-else>/</span>
            </td>
            <td>{{ placement.anchor || '?' }}</td>
            <td>{{ placement.status }}</td>
            <td>
              <a :href="'/pbn/' + placement.pbn.punyDomain" v-if="placement.pbn">{{ placement.pbn.domain }}</a>
              <span v-else>/</span>
            </td>
            <td>{{ placement.client.name }}</td>
            <td>{{ placement.placed | aTime('DD.MM.Y') }}</td>
            <td v-if="user.admin">{{ placement.placer ? placement.placer.name : '?' }}</td>
            <td>
              <i class="fa fa-check green" v-if="placement.confirmed"></i>
              <i class="fa fa-question orange" v-else></i>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      placements: [],
      uniquePlacementLinks: [],
      uniquePlacementURL: [],
      filters: {}
    }
  },
  mounted () {
    this.getPlacements()
  },
  computed: {
    ...mapGetters({
      order: 'getLinkOrder',
      user: 'getUser'
    }),
    filterPlacedLinks () {
      let newPlacements = this.placements
      if (this.filters['link'] !== null && this.filters['link'] !== undefined) {
        newPlacements = newPlacements.filter(p => p.link === this.filters['link'])
      }
      if (this.filters['url'] !== null && this.filters['url'] !== undefined) {
        newPlacements = newPlacements.filter(p => p.url === this.filters['url'])
      }
      if (this.filters['indexed'] !== null && this.filters['indexed'] !== undefined) {
        newPlacements = newPlacements.filter(p => p.confirmed === this.filters['indexed'])
      }
      return newPlacements
    }
  },
  methods: {
    getPlacements () {
      axios.get('pbn/links/order/' + this.$route.params.id + '/placements')
        .then(r => {
          this.placements = r.data.data
          this.uniquePlacementLinks = [...new Set(this.placements.map(p => p.link))]
          this.uniquePlacementURL = [...new Set(this.placements.map(p => p.url).filter(pUrl => pUrl !== null))]
        })
        .catch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Links/Order/Tabs/Placements.vue